import {
  tabCloser,
  tabIcons,
  tabTemplate,
  categoryCodeTab,
} from '@/layout/state/state';
import { matchCodeUrl } from '@/constants/urls';
import UserGroupActions from '../containers/UserGroupActions';
import { closeUserGroup } from '../actions/usergroups/read';
import UserGroupPanel from '../components/UserGroupPanel';

export default (urls, access) => ({
  ...tabTemplate('usergroup', UserGroupPanel, matchCodeUrl(urls), UserGroupActions),
  ...tabCloser('closeUserGroupTab', closeUserGroup),
  ...tabIcons('users'),
  access,
  componentState: ({ args, url }) => categoryCodeTab(url, args[2]),
  order: 855,
});
